import { IPayloadDelete } from '~/utils/interface/customer';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IAreaScope, IEditAreaScope, IParamsGetAreaScope, IResponseGetAreaScope } from '~/utils/interface/areaScope';

const url = `api/admin/area-scopes`;

const areaScopeApi = {
  create(data: IEditAreaScope) {
    return axiosClient.post<IApiBaseResponse<IAreaScope>>(url, data);
  },
  getList(params: IParamsGetAreaScope) {
    return axiosClient.get<IApiBaseResponse<IResponseGetAreaScope>>(`api/admin/area-scopes`, { params });
  },
  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<IAreaScope>>(`api/admin/area-scopes/${id}`);
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  update(id: string | undefined, data: IEditAreaScope) {
    return axiosClient.put<IApiBaseResponse<IAreaScope>>(`api/admin/area-scopes/${id}`, data);
  },
};

export default areaScopeApi;
